import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import Sidebar from './Sidebar/Sidebar';
import ReportBugButton from '../common/BugReport/ReportBugButton';
import { BugReportProvider } from '../../context/BugReportContext.jsx';
import { newsService } from '../../services/news.service.js';
import logoIcon from '../../assets/icons/ep256.png';
import './DashboardLayout.css';

// Module-level ref to prevent duplicate categories fetch across remounts
let categoriesFetchInitiated = false;

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [categories, setCategories] = useState([]);

  // Fetch categories once at layout level (shared across all dashboard pages)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await newsService.getCategories();
        if (response.success) {
          setCategories([{ id: 'all', name: 'All' }, ...response.data.categories]);
        }
      } catch (err) {
        console.error('Failed to fetch categories:', err);
        // Fallback to hardcoded list if API fails
        setCategories([
          { id: 'all', name: 'All' },
          { id: 'National', name: 'National' },
          { id: 'Business', name: 'Business' },
          { id: 'Sports', name: 'Sports' },
          { id: 'World', name: 'World' },
          { id: 'Politics', name: 'Politics' },
          { id: 'Technology', name: 'Technology' },
          { id: 'Startup', name: 'Startup' },
          { id: 'Entertainment', name: 'Entertainment' },
          { id: 'Miscellaneous', name: 'Miscellaneous' },
          { id: 'Hatke', name: 'Hatke' },
          { id: 'Science', name: 'Science' },
          { id: 'Automobile', name: 'Automobile' },
          { id: 'Education', name: 'Education' },
          { id: 'Environment', name: 'Environment' },
          { id: 'Travel', name: 'Travel' },
          { id: 'Fashion', name: 'Fashion' },
        ]);
      }
    };

    if (!categoriesFetchInitiated) {
      fetchCategories();
      categoriesFetchInitiated = true;
    }
  }, []);

  // Set body background color on mount
  useEffect(() => {
    document.body.style.backgroundColor = '#f9fafb';
    return () => {
      document.body.style.backgroundColor = '#ffe6e4';
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <BugReportProvider>
      <div className={`dashboard-layout ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Mobile Menu Toggle Button */}
        <button
          className="mobile-menu-toggle"
          onClick={toggleSidebar}
          aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
        >
          {sidebarOpen ? <X size={15} /> : <Menu size={15} />}
        </button>

        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="dashboard-main">
          {/* Header Section */}
          <header className="dashboard-header">
            <img src={logoIcon} alt="EasyPanel Logo" className="header-logo" />
            <div className="header-brand">
              <div className="brand-container">
                <span className="brand-name">EasyPanel</span>
                <span className="by-inshorts">by Inshorts</span>
              </div>
            </div>
          </header>

          <Outlet context={{ categories }} />
        </main>

        {/* Floating report-a-bug button */}
        <ReportBugButton />
      </div>
    </BugReportProvider>
  );
};

export default DashboardLayout;
